module.exports = __webpack_public_path__ + "e325a8bd056d5e6e2f9509eea11dc65e.woff2";